import { combineReducers } from 'redux';
import manager from './manager.js';
import companies from './companies.js';
import task from './task.js';
import notification from './notification.js';
import dayoff from './dayoff.js';
import message from './message.js';
import agent from './agent.js';


export default combineReducers(
    {
        manager,companies,task,notification,dayoff,message,agent
    },
);
